import ReactGA from 'react-ga';

class Analytics {
    sendEvent(event) {
        event.ga && ReactGA.event({
            category: event.ga.category, 
            action: event.ga.action, 
            label: event.ga.label, 
            value: event.ga.value
        });
    }

    sendPageView(page) {
        ReactGA.pageview(page);
    }

    sendTiming(category, variable, value, label) {
        ReactGA.timing({
            category,
            variable,
            value,
            label
        });
    }

    sendException(description, fatal) {
        ReactGA.exception({
            description,
            fatal
        });
    }

    setPage(page) {
        ReactGA.set({ 
            page
        });
    }

    setUserId(userId) {
        ReactGA.set({ 
            userId
        });
    }
}

export default new Analytics();


/** WEBPACK FOOTER **
 ** ./src/shared/google-analytics/Analytics.js
 **/